import LeituraQRCode from './LeituraQRCode.vue';

const routes = [
    {
        path: '/checkins/impressoras/leitura-qrcode',
        name: 'Checkins_Impressoras_LeituraQRCode',
        component: LeituraQRCode,
        meta: { rules: ['CHECKINS-EVENTOS-15'] },
    },
];

export default routes;
